import styled from "@emotion/styled";


export const CodeInputContainer = styled.div`
    display:flex;
    width:100%;
    gap:15px;
    justify-content: center;
`;

export const SingleInput = styled.input`
    border: 1px solid #afafaf;
    width:10vw;
    max-width: 40px;
    max-height: 60px;
    aspect-ratio: 1 / 1.3;
    border-radius: 10px;
    font-size: clamp(16px, 7vw, 32px);
    text-align: center;
    outline: none;
    -moz-appearance: textfield;
      ::-webkit-outer-spin-button,
      ::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    :focus{
        box-shadow: 0 0 2px 1px rgba(42, 132, 142, 0.8);
    }
`;

export const ResetCode = styled.button`
    width:10vw;
    max-width: 40px;
    border:0;
    outline:none;
    border-radius: 10px;
    background:#2A848E;

    svg{
        width:70%;
        margin-top: 2px;
        path{
            fill:#fff;
        }
    }
`;